import React from "react";
import styles from "./style.module.css";
import { Table } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Loading from "../Loading";
import EmptyError from "../EmptyError";
import Tooltip2 from "../Tooltip";
import Slct from "../Slct";

const TableResponsive = props => {
  const navigate = useNavigate();
  const { table, className = "", print: printType = "table", emptyMsg, noborder_header } = props;

  const constructElement = (type, props) => {
    if (type === "select") {
      return <Slct {...props} />;
    } else return <></>;
  };

  let body = table?.body?.map((__row, __row_i) => ({
    ...__row,
    show_spoiler: !!__row?.show_spoiler,
    element: __row.element || constructElement(__row?.type, __row?.props),
    extraRow: __row.extraRow?.map(__extra => ({
      element: __extra.element || constructElement(__extra?.type, __extra?.props),
    })),
  }));

  return (
    <>
      {!!table?.loading ? (
        <Loading />
      ) : body?.length > 0 ? (
        <>
          <div className={`d-block d-lg-none ${printType === "table" ? "d-print-none" : ""}`}>
            {body?.map((__row, __row_i) => {
              return (
                <div
                  className={styles.table_card}
                  style={{ cursor: __row.link || __row.onClick ? "pointer" : "default" }}
                  key={__row.key || __row_i}
                >
                  {__row?.extraRow?.map(__extra => (
                    <div className={styles.table_content} key={`${__row_i}-row-extrarow`}>
                      {__extra.element}
                    </div>
                  ))}
                  {__row?.data.map((__col, __col_i) => {
                    return (
                      <React.Fragment key={__col_i}>
                        <div
                          onClick={() => {
                            __row.link && navigate(__row.link);
                            __row.onClick && __row.onClick();
                            if (!!__col.spoiler) {
                              let el = document.querySelector(`[spoiler='${__col.id}-${__row_i}-${__col_i}']`);
                              let view = el.getAttribute("data-show");
                              view === "true"
                                ? el.setAttribute("data-show", "false")
                                : el.setAttribute("data-show", "true");
                            }
                          }}
                          className={__col.className || ""}
                        >
                          {!table.head[__col_i]?.hide_on_mobile && (
                            <h3 className={styles.table_title}>{table.head[__col_i]?.data}</h3>
                          )}
                          <div className={styles.table_content}>{__col.element}</div>
                        </div>
                        {!!__col.spoiler ? (
                          <div
                            spoiler={`${__col.id}-${__row_i}-${__col_i}`}
                            data-show="false"
                            className={styles.table_logs}
                          >
                            {__col.spoiler}
                          </div>
                        ) : (
                          ""
                        )}
                      </React.Fragment>
                    );
                  })}
                </div>
              );
            })}
          </div>
          <div className={`d-none d-lg-block ${printType === "table" ? "d-print-block" : ""} ${className}`}>
            <Table className={styles.table}>
              <thead>
                <tr>
                  {table.head.map((__row, __row_i) => (
                    <th
                      style={{
                        paddingLeft: "0",
                        width: __row.table_width || "",
                        textAlign: !!__row.sub ? "center" : "",
                      }}
                      colSpan={__row.sub?.length || 1}
                      className={__row.className || ""}
                      data-noborder={noborder_header}
                      key={`head-${__row_i}`}
                    >
                      {__row.data}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {table.head.some(__row => __row.sub) && (
                  <tr className={`${styles.sub_h} mt-4`}>
                    {table.head.map((__row, __row_i) => (
                      <React.Fragment key={`subhead-${__row_i}`}>
                        {!!__row.sub ? (
                          <>
                            {__row.sub.map(__sub => (
                              <td>
                                <span>{__sub.data}</span>
                              </td>
                            ))}
                          </>
                        ) : (
                          <td></td>
                        )}
                      </React.Fragment>
                    ))}
                  </tr>
                )}

                {body?.map((__row, __row_i) => {
                  return (
                    <React.Fragment key={`body-${__row_i}`}>
                      <tr
                        onClick={__ev => {
                          if (!__row.spoilerOnRowClick) return;
                          const _clickedInteractive = __ev.target.closest("button, a, input, select, .dropdown-menu");
                          const _clickedSpoilerCell = __ev.target.closest(`td.${styles.spoiler}`);
                          if (_clickedInteractive || _clickedSpoilerCell) return;
                          __row.show_spoiler = !__row.show_spoiler;
                          __ev.currentTarget.nextSibling?.setAttribute(
                            "data-show",
                            __row.show_spoiler ? "true" : "false",
                          );
                        }}
                        style={{
                          opacity: __row.disabled ? ".5" : "1",
                          boxShadow: `inset 4px 0 0 0 ${__row.border}`,
                          cursor: __row.spoilerOnRowClick ? "pointer" : "",
                        }}
                        className={`${styles.table_row} ${__row.className || ""} ${!!__row.bold ? "fw-bold" : ""}`}
                        data-selected={__row.selected ? "true" : "false"}
                        data-row={__row_i % 2 === 0 ? "even" : "odd"}
                      >
                        {__row?.data.map((__col, __col_i) => (
                          <td
                            onClick={__ev => {
                              if (!!__col.spoiler) {
                                __row.show_spoiler = !__row.show_spoiler;
                                __ev.currentTarget
                                  .closest("tr")
                                  .nextSibling.setAttribute("data-show", __row.show_spoiler ? "true" : "false");
                              } else {
                                // __row.link && navigate(__row.link);
                                __row.onClick && __row.onClick();
                              }
                            }}
                            style={{
                              cursor:
                                __row.link || __row.onClick || __row.spoilerOnRowClick ? "pointer" : "default",
                              boxShadow: __col_i === 0 && __row.border ? `inset 4px 0 0 0 ${__row.border}` : "",
                              padding: ".5rem .5rem .5rem 0",
                            }}
                            className={`${styles.column} ${__col.className || ""} ${
                              !!__col.spoiler ? styles.spoiler : ""
                            }`}
                            key={`${__row.key || __row_i}-${__col_i}`}
                          >
                            {__col_i === 0 && !!__row.tooltip && (
                              <Tooltip2 tip={__row.tooltip} placement="bottom">
                                <div className={styles.tooltip}></div>
                              </Tooltip2>
                            )}
                            <span style={{ paddingLeft: __col_i === 0 && __row.border ? "8px" : "0" }}>
                              {__col.element}
                            </span>
                            {!!__row.link && (
                              <a href={__row.link} className={styles.link}>
                                <span className="visually-hidden">Ver detalhes</span>
                              </a>
                            )}
                          </td>
                        ))}
                      </tr>
                      {__row?.data?.map((__col, __col_i) => {
                        if (__col.spoiler) {
                          return (
                            <tr
                              className={styles.table_spoiler}
                              data-show={`${__row.show_spoiler ? "true" : "false"}`}
                              key={`${__row_i}-row-spoiler`}
                            >
                              <td colSpan={__row?.data.length}>{!!__col.spoiler ? <div>{__col.spoiler}</div> : ""}</td>
                            </tr>
                          );
                        }
                        return null;
                      })}
                      {__row?.extraRow?.length > 0 && (
                        <tr className={styles.table_extrarow} key={`${__row_i}-row-extrarow`}>
                          {__row?.extraRow?.map((__extra, __extra_i) => (
                            <td
                              colSpan={__row?.data?.length}
                              key={__extra.id || `${__row.key || __extra_i}-extra-${__extra_i}`}
                            >
                              <div>{__extra.element}</div>
                            </td>
                          ))}
                        </tr>
                      )}
                    </React.Fragment>
                  );
                })}
              </tbody>
            </Table>
          </div>
          {/* TABLE STRUCTURE */}
        </>
      ) : (
        <EmptyError msg={<p> {emptyMsg || "Não encontramos nenhum resultado para sua busca."}</p>} />
      )}
    </>
  );
};

export default TableResponsive;
